import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import numeral from "numeral";
import { useState } from "react";
import { Tooltip } from "antd";

const AccountingTab = ({data}) => {

  const [dataDebitToIterate, setDataDebitToIterate] = useState([]);
  const [dataCreditToIterate, setDataCreditToIterate] = useState([]);

  useEffect(() => {
    setDataDebitToIterate(data?.accountingLines?.debits);
  }, [data]);

  useEffect(() => {
    setDataCreditToIterate(data?.accountingLines?.credits);
  }, [data]);

  return (
    <>
      <div className="accounting-block debits">
        <div className="debits-credits-block-row">
          <div className="first-block">
            <b className="title"><FormattedMessage id="preCog.accountingTab.accountingAccount"/></b>
          </div>
          <div className="second-block">
            <b className="title"><FormattedMessage id="preCog.accountingTab.debit"/></b>
          </div>
        </div>
        {dataDebitToIterate?.map((d, index) => {
          return (
            <div key={index} className="debits-credits-block-row">
              <div className="accounting-account-description">
                <div className="first-block">
                  <Tooltip placement="bottom" 
                    title={d.accountDesc} color={"rgb(0, 80, 117)"} 
                    getPopupContainer={trigger => trigger.parentNode}>
                    <p className="description" style={{height: "auto"}}>{d.accountDesc}</p>
                  </Tooltip>
                </div>
              </div>
              <div className="second-block">
                <p className="description">{numeral(Math.abs(d?.debit)).format("0,0.00")} € </p>
              </div>
            </div>
          );
        })
        }
      </div>
      <div className="accounting-block">
        <div className="debits-credits-block-row" style={{marginLeft: "17px"}}>
          <div className="first-block">
            <b className="title"><FormattedMessage id="preCog.accountingTab.accountingAccount"/></b>
          </div>
          <div className="second-block">
            <b className="title"><FormattedMessage id="preCog.accountingTab.credit"/></b>
          </div>
        </div>
        {dataCreditToIterate?.map((c, index) => {
          return (
            <div key={index} className="debits-credits-block-row" style={{marginLeft: "17px"}}>
              <div className="accounting-account-description">
                <div className="first-block">
                  <Tooltip 
                    placement="bottom" title={c.accountDesc} color={"rgb(0, 80, 117)"}
                    getPopupContainer={trigger => trigger.parentNode}>
                    <p className="description" style={{height: "auto"}}>{c.accountDesc}</p>
                  </Tooltip>
                </div>
              </div>
              <div className="second-block">
                <p className="description">{numeral(Math.abs(c?.credit)).format("0,0.00")} € </p>
              </div>
            </div>
          );
        })
        }
      </div>
    </>
  );
};

export default AccountingTab;
